import React,{useEffect} from "react";
import logo from "../newboy.png";
import WOW from "wowjs";
const About = () => {
	useEffect(() => {
		new WOW.WOW({
			live: false,
		}).init();
	});
	return (
		<div id="about">
			<h2>about me</h2>
			<div className="about">
				<div className="img-container wow animate__animated animate__fadeInLeft" data-wow-duration="2s">
					<img src={logo} alt="" />
				</div>
				<p className="wow animate__animated animate__fadeInRight" data-wow-duration="2s">
					<span className="colored-orange ">hello!</span>I'm Ibrahim Abdulsalam, and I like making things for the internet. I've always had a creative side and a logical side to me. When I made the decision to try editing unique Tublir themes in 2020, my passion in web programming really began to take off. I knew web
					development would be the ideal fit as soon as I learned about it. I could create using my artistic side and code using my logical side. Being a designer and developer also gives me the opportunity to ensure that no details are lost in translation. I am skilled in HTML, CSS, JavaScript, FIGMA, Bootstrap, and
					REACT.
				</p>
			</div>
		</div>
	);
};

export default About;
